import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth';
import {ADD_TEEN_EVENTS} from '@/app/auth/events/AddTeenEvents';
import {REQUEST_CARD_EVENTS} from '@/app/auth/events/RequestCardEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {IEventBaseDataSchema} from '@/services';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackApiTeenAddressPhysicalCardSuccess = useCallback(
    (baseSchema: IEventBaseDataSchema) => {
      trackEvent(
        REQUEST_CARD_EVENTS.API_TEENADDRESS_REQUEST_PHYSICAL_CARD_SCHEDULE_SUCCESS,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          ...baseSchema,
        },
      );
    },
    [trackEvent],
  );

  const trackApiTeenAddressPhysicalCardError = useCallback(
    (baseSchema: IEventBaseDataSchema, error: any) => {
      trackEvent(
        REQUEST_CARD_EVENTS.API_TEENADDRESS_REQUEST_PHYSICAL_CARD_SCHEDULE_ERROR,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          ...baseSchema,
        },
        error,
      );
    },
    [trackEvent],
  );

  const trackApiErrorRequestCard = useCallback(
    (error: any) => {
      trackEvent(
        ADD_TEEN_EVENTS.API_ERROR_REQUEST_CARD,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          FamilyMember: {
            role: RolesAccount.TEEN,
          },
        },
        error,
      );
    },
    [trackEvent],
  );

  return {
    trackApiErrorRequestCard,
    trackApiTeenAddressPhysicalCardSuccess,
    trackApiTeenAddressPhysicalCardError,
  };
};
